import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link, useParams } from 'react-router-dom';
import '../css/PrincipalDashboard.css';
import axios from 'axios';

const Sidebar = () => {
  const userRole = localStorage.getItem('role');
  const userId = localStorage.getItem('userId') || '1';
  const navigate = useNavigate();
  const { id } = useParams(); // URL se :id check karne ke liye
  const location = useLocation();
  
  const dashboardPath = userRole === 'admin' ? '/admin' : `/admin/principal/${userId}`;

  // LOGIC: Agar URL mein koi ID hai, ya state mein viewMode admin hai, aur dekhne wala admin hai, 
  // tabhi pata chalega ki admin kisi aur ka dashboard dekh raha hai.
  const isAdminViewingUser = (id || location.state?.viewMode === "admin") && userRole === "admin";

  return (
    <aside className="sidebar">
      <nav className="nav-menu">
        <Link to={dashboardPath} className="nav-item active" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <span>🏠</span> Dashboard
        </Link>
        <div className="nav-item"><span>🎓</span> My Enrollments</div>
        
        {/* FIX: Return tab sirf tabhi dikhega jab admin kisi aur ka dashboard check kar raha ho */}
        {isAdminViewingUser && (
          <div className="nav-item" onClick={() => navigate('/admin')} style={{ cursor: 'pointer' }}>
            <span>⬅️</span> Return
          </div>
        )}
      </nav>
    </aside>
  );
};

const PrincipalDashboard = () => {
  const { state } = useLocation();
  const [userData, setUserData] = useState(state?.user || JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check karo ki kya humare paas full data hai? 
    // Agar principalSchoolName nahi hai, toh API call karo
    if (!userData || !userData.principalSchoolName) {
      fetchFullProfile();
    }
  }, []);

  const fetchFullProfile = async () => {
  setLoading(true);
  try {
    const token = localStorage.getItem("token");
    
    // Yahan check karo ki token sahi mein mil raha hai ya nahi
    console.log("Token sent:", token); 

    const response = await axios.get('https://api.satrixstore.in/api/me', {
      headers: { 
        'Authorization': `Bearer ${token}` // 'Bearer' aur space zaroori hai
      }
    });

    setUserData(response.data.data);
    localStorage.setItem("user", JSON.stringify(response.data.data));
  } catch (error) {
    console.error("Error fetching full profile:", error.response?.data || error.message);
  } finally {
    setLoading(false);
  }
};

  // Agar load ho raha hai toh loading screen dikhao
  if (loading) return <div className="loading">Loading Dashboard...</div>;

  // Ab 'user' variable dynamic data se bhara hoga
  const user = userData || {};

  const students = [
    { id: 1, name: 'Aarav Sharma', stream: 'Science (PCM)', course: 'B.Tech', status: 'New Lead', location: 'Bangalore', contact: '+91 98765 43210' },
    { id: 2, name: 'Ananya Verma', stream: 'Commerce', course: 'BBA', status: 'In Progress', location: 'Delhi', contact: '+91 91234 56789' },
    { id: 3, name: 'Rohan Mehta', stream: 'Science (PCB)', course: 'B.Sc. (Nursing)', status: 'Contacted', location: 'Chandigarh', contact: '+91 99887 66554' }
  ];

  return (
    <div className="principal-dashboard-root">
        <Sidebar/>
        <div className="principal-dashboard-container">
            <div className="main-content">
                <header className="welcome-header">
                <p>Welcome back, Principal 👋</p>
                <h1>{user.fullName || "Ms. Pooja Rajpoot"}</h1>
                </header>

                <div className="profile-hero-card">
                <div className="profile-main">
                    <div className="avatar">{user.fullName ? user.fullName.charAt(0) : 'P'}</div>
                    <div className="info">
                    <h3>{user.fullName || "Ms. Pooja Rajpoot"}</h3>
                    <p><span>📧</span> {user.email || "pooja.rajpoot@evridya.com"}</p>
                    <p><span>📱</span> {user.phoneNumber || "+91 99966 77788"}</p>
                    <p><span>📍</span> {user.city || "Rohtak, Haryana"}</p>
                    </div>
                </div>
                <div className="stats-grid">
                    <div className="stat-item"><span>🏫</span><label>School:</label> <strong>{user.principalSchoolName || "DPS Senior Secondary"}</strong></div>
                    <div className="stat-item"><span>📚</span><label>Board:</label> <strong>{user.principalBoard || "CBSE"}</strong></div>
                    <div className="stat-item"><span>👥</span><label>Total Students:</label> <strong>{user.principalTotalStudents || "842"}</strong></div>
                    <div className="stat-item"><span>👨‍🏫</span><label>Total Teachers:</label> <strong>48</strong></div>
                </div>
                </div>

                <div className="table-card">
                <div className="table-header">
                    <h3>My Enrollments</h3>
                    <div className="search-filter">
                    <input type="text" placeholder="Search student..." />
                    </div>
                </div>
                <table>
                    <thead>
                    <tr><th>#</th><th>Student Name</th><th>12th Stream</th><th>Interested Course</th><th>Location</th><th>Status</th></tr>
                    </thead>
                    <tbody>
                    {students.map((s, index) => (
                      <tr key={s.id}>
                        <td data-label="#">{index + 1}</td>
                        <td data-label="Student Name">
                          <strong>{s.name}</strong>
                          <br />
                          <small>{s.contact}</small>
                        </td>
                        <td data-label="Stream">{s.stream}</td>
                        <td data-label="Course">{s.course}</td>
                        <td data-label="Location">{s.location}</td>
                        <td data-label="Status">
                          <span className={`status-pill ${s.status.toLowerCase().replace(' ', '-')}`}>
                            {s.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
       </div>
    </div>
  );
};

export default PrincipalDashboard;